import { createFileRoute } from '@tanstack/react-router'
import { Helmet } from 'react-helmet-async'
import { Input, Toggle } from '@/components/ui'
import { formatDocumentTitle } from '@/lib/document-title'

export const Route = createFileRoute('/_dev/ui-preview/inputs')({
  component: InputsPreviewPage,
})

function InputsPreviewPage() {
  return (
    <>
      <Helmet>
        <title>{formatDocumentTitle('Input Components', 'Dev')}</title>
      </Helmet>
      <div className="min-h-screen bg-background p-8">
        <div className="mx-auto max-w-4xl space-y-12">
          <header>
            <h1 className="text-2xl font-semibold text-text-primary">
              Input Components
            </h1>
            <p className="text-text-secondary mt-2">
              Form input components preview
            </p>
          </header>

          {/* Text Inputs */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-text-primary border-b pb-2">
              Text Inputs
            </h2>
            <div className="space-y-4 max-w-md">
              <Input label="Email" placeholder="Enter your email" />
              <Input
                label="Password"
                type="password"
                placeholder="Enter password"
              />
              <Input
                label="With Helper Text"
                placeholder="Enter value"
                helperText="This is helper text"
              />
              <Input
                label="With Error"
                placeholder="Enter value"
                error="This field is required"
              />
              <Input
                label="Disabled"
                placeholder="Disabled input"
                disabled
              />
            </div>
          </section>

          {/* Toggles */}
          <section className="space-y-4">
            <h2 className="text-xl font-semibold text-text-primary border-b pb-2">
              Toggles
            </h2>
            <div className="space-y-4">
              <Toggle label="Enable notifications" />
              <Toggle label="Dark mode" defaultChecked />
              <Toggle label="Disabled toggle" disabled />
            </div>
          </section>
        </div>
      </div>
    </>
  )
}
